<template>
  <v-card class="mx-auto my-8">
    <v-img
      v-if="image"
      :src="image"
      max-height="350"
      cover
      class="shadowed-image"
      gradient="to bottom right, rgba(0, 0, 0, 0.1), transparent 20%, rgba(0, 0, 0, 0.1) 80%"
    ></v-img>

    <v-card-title style="word-break: break-word">
      <v-badge content="Neu" inline v-if="isNew">
        {{ title }}
      </v-badge>
      <template v-else>
        {{ title }}
      </template>
    </v-card-title>

    <v-card-subtitle>
      <span :title="date | formatDate">{{ formattedDate }}</span>
    </v-card-subtitle>

    <v-card-text>
      <div v-html="description" />

      <v-chip-group>
        <v-chip class="non-clickable" v-for="tag in tags" :key="tag">{{
          tag
        }}</v-chip>
      </v-chip-group>
    </v-card-text>

    <v-card-actions v-if="link">
      <v-btn text :href="link" class="float-right" target="_blank">
        Mehr erfahren
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mdiMoonFull } from "@mdi/js"

export default defineComponent({
  name: "ChangelogCard",
  methods: {
    mdiMoonFull() {
      return mdiMoonFull
    },
  },
  props: {
    image: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: false,
    },
    date: {
      type: Date,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  setup(props) {
    const formattedMonth = props.date.toLocaleString("de-DE", { month: "long" })
    const formattedYes = props.date.getFullYear()
    const formattedDate = `${formattedMonth} ${formattedYes}`
    return {
      formattedDate,
    }
  },
})
</script>
<style scoped>
.non-clickable {
  cursor: default;
  pointer-events: none;
}
.shadowed-image {
  box-shadow: inset 0 0 50px -15px rgba(0, 0, 0, 0.25);
}
</style>
